import { render, staticRenderFns } from "./EmpresaUploadCer.vue?vue&type=template&id=27395cba&"
import script from "./EmpresaUploadCer.vue?vue&type=script&lang=js&"
export * from "./EmpresaUploadCer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports